export default "__VITE_ASSET__13bf2a8f__"